document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContador();
  initGaleriaProducto();
  initVariantes();
  initFaqAcordeon();
  initFormResena();
});

function initReveals() {
  var els = document.querySelectorAll('.bk-reveal, .bk-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('bk-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('bk-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-bk-contador]');
  if (!els.length) return;
  var animado = new WeakSet();
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || animado.has(entry.target)) return;
      animado.add(entry.target);
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-bk-contador'));
      var sufijo = el.getAttribute('data-bk-sufijo') || '';
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var prog = Math.min((ts - inicio) / dur, 1);
        var val = Math.round(fin * (1 - Math.pow(1 - prog, 3)));
        el.textContent = val + sufijo;
        if (prog < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function cambiarImagenGaleria(url) {
  var wrap = document.querySelector('[data-bk-galeria]');
  if (!wrap || !url) return;
  var principal = wrap.querySelector('[data-bk-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-bk-galeria-mini]');
  if (!principal || principal.src === url) return;
  principal.style.opacity = '0';
  setTimeout(function () {
    principal.src = url;
    principal.style.opacity = '1';
  }, 150);
  minis.forEach(function (m) {
    m.classList.toggle('bk-mini-activa', m.getAttribute('data-full') === url);
  });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-bk-galeria]');
  if (!wrap) return;
  var minis = wrap.querySelectorAll('[data-bk-galeria-mini]');
  if (!minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      cambiarImagenGaleria(mini.getAttribute('data-full'));
    });
  });
}

function initVariantes() {
  var form = document.querySelector('[data-bk-form-producto]');
  if (!form) return;
  var datosEl = document.querySelector('[data-bk-variantes-json]');
  if (!datosEl) return;
  var variantes;
  try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-bk-opcion]');
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-bk-precio]');
  var precioComparadoEl = document.querySelector('[data-bk-precio-comparado]');
  var btnComprar = form.querySelector('[data-bk-btn-comprar]');

  function varianteSeleccionada() {
    var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
  }

  function formatoPrecio(centavos) {
    return (centavos / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD' });
  }

  function actualizar() {
    var v = varianteSeleccionada();
    if (!v) return;
    inputId.value = v.id;
    if (precioEl) precioEl.textContent = formatoPrecio(v.price);
    if (precioComparadoEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        precioComparadoEl.textContent = formatoPrecio(v.compare_at_price);
        precioComparadoEl.style.display = '';
      } else {
        precioComparadoEl.style.display = 'none';
      }
    }
    if (btnComprar) {
      btnComprar.disabled = !v.available;
      btnComprar.textContent = v.available ? btnComprar.getAttribute('data-texto-disponible') : btnComprar.getAttribute('data-texto-agotado');
    }
    if (v.featured_image) {
      cambiarImagenGaleria(v.featured_image);
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

// Formulario de reseñas: Shopify solo acepta autor/email/texto en un
// comentario, así que la puntuación viaja al principio del texto con el
// marcador [rating:N], que luego el tema extrae y oculta.
// IMPORTANTE: el envío tiene que ser normal (no fetch). Shopify protege los
// comentarios con un CAPTCHA antispam y rechaza los envíos por fetch con
// "Missing CAPTCHA token".
function initFormResena() {
  var form = document.querySelector('[data-bk-form-resena]');
  if (!form) return;
  var texto = form.querySelector('[data-bk-resena-texto]');
  if (!texto) return;

  form.addEventListener('submit', function () {
    var elegida = form.querySelector('[data-bk-rating]:checked');
    if (!elegida) return;
    if (texto.value.indexOf('[rating:') !== 0) {
      texto.value = '[rating:' + elegida.value + '] ' + texto.value;
    }
  });
}

function initFaqAcordeon() {
  var items = document.querySelectorAll('[data-bk-faq-item]');
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-bk-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('bk-faq-abierta');
      item.closest('[data-bk-faq]').querySelectorAll('[data-bk-faq-item]').forEach(function (i) {
        i.classList.remove('bk-faq-abierta');
      });
      if (!abierta) item.classList.add('bk-faq-abierta');
    });
  });
}
